module.exports = __webpack_public_path__ + "media/Bring_productivity_up_and_costs_down.437caf63.mp4";